<div class="instigator-tile" [ngClass]="{'instigator-tile-height': isFav}">
    <div class="instigator-tile-group">
        <div class="instigator-tile-main-title an-h-line-height" [attr.aria-label]='title'>
            {{title}}
        </div>
        <div class="instigator-tile-sub-title an-p-line-height"  [attr.aria-label]='subTitle'>
            {{subTitle}}
        </div>
        <div class="instigator-tile-inventory">
            <a  tabindex="0" role="button" [attr.aria-label]='buttonText' class="instigator-tile-button  ada-button-focus" (click)="tealiumCallShopNow()" [href]="carsForSaleLinkUrl()" > {{buttonText}}
            </a>
           
        </div>
    </div>
</div>